import { render } from "./AddProductToCartModalManager.vue?vue&type=template&id=455b4928"
import script from "./AddProductToCartModalManager.vue?vue&type=script&lang=js"
export * from "./AddProductToCartModalManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__